import Banner from "ds/components/Banner";
import FeedbackActions from "ds/components/Feedback/Actions";
import Link from "ds/components/Link";

import { DASHBOARD_WIDGETS_OPEN_TOFU_MIGRATION_GUIDE_URL } from "../constants";

const DashboardWidgetsOpenTofuMigrationDeprecationBanner = () => (
  <Banner variant="warning" fullWidth title="OpenTofu through the Terraform vendor is deprecated">
    The legacy Terraform vendor with the OpenTofu workflow tool will be removed in the future.
    <FeedbackActions>
      <Link size="small" href={DASHBOARD_WIDGETS_OPEN_TOFU_MIGRATION_GUIDE_URL} target="_blank">
        OpenTofu migration guide
      </Link>
    </FeedbackActions>
  </Banner>
);

export default DashboardWidgetsOpenTofuMigrationDeprecationBanner;
